// extracted by mini-css-extract-plugin
module.exports = {"select-wrap":"select-wrap__bhsxE","icon":"icon__1p6fQ","select":"select__3KBW4","placeholder":"placeholder__yecr4"};